import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

export default class LocationOverviewPoliciesRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  titleToken = 'Policies';

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('ava-feature')) {
      void this.router.transitionTo('location-overview');
      return;
    }

    if (!this.globalOverviewAccess.canVisitFlows) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
